module.exports = __webpack_public_path__ + "img/09.64f77625.png";